import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/freelance-rate',
  component: () => import('../../routes/FreelanceRate.svelte'),
  card: {
    id: 'freelance-rate',
    title: 'Freelance Rate',
    description: 'Convert your desired salary into a freelance hourly rate that covers taxes, expenses, time off, and profit margin.',
    icon: 'work',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/freelance-rate',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Freelance Rate Calculator – Salary to Hourly Rate Converter',
    description: 'Free freelance rate calculator. Convert your desired salary into an hourly, daily, weekly, or monthly freelance rate. Accounts for self-employment taxes, business expenses, time off, and profit margin. Know your worth before you quote.',
  },
};

export default meta;
